import {
  establishSecureChannel,
  type SecureChannelFailure,
  type SecureInputsHandshakeError,
} from "@highnoteplatform/types";

import { iframeOrigin, packageName, packageVersion } from "./config";

const FAILURE_MESSAGES: Record<SecureChannelFailure, string> = {
  FRAME_UNREACHABLE:
    "Unable to reach the checkout frame. Please try again or contact support.",
  HANDSHAKE_TIMEOUT:
    "Checkout frame did not respond. Please try again or contact support.",
};

interface EstablishCheckoutChannelConfig {
  frame: HTMLIFrameElement;
  uuid: string;
  clientToken: string;
  onError: (error: SecureInputsHandshakeError) => void;
  onHandshakeAck?: () => void;
}

// Checkout facade over the shared secure-channel machinery: delivers the client
// token over a private MessagePort after frame load, mapping failures to the
// public SecureInputsHandshakeError wording. Checkout carries no paymentCardId.
// Reuses SecureInputsHandshakeError (already part of the checkout onTokenizeError
// union) rather than introducing a checkout-specific error type — the checkout
// error surface is intentionally secure-inputs-flavored.
export const establishCheckoutChannel = ({
  frame,
  uuid,
  clientToken,
  onError,
  onHandshakeAck,
}: Readonly<EstablishCheckoutChannelConfig>): (() => void) =>
  establishSecureChannel({
    frame,
    iframeOrigin,
    uuid,
    clientToken,
    sdkName: packageName,
    sdkVersion: packageVersion,
    onHandshakeAck,

    onFailure: (failure) => {
      onError({
        name: "SecureInputsHandshakeError",
        message: FAILURE_MESSAGES[failure],
      });
    },
  });
